/* @flow */

import type { NETGEM_API_V8_FEED_ITEM } from '../../../libs/netgemLibrary/v8/types/FeedItem';
import type { NETGEM_API_V8_PARENTAL_GUIDANCE } from '../../../libs/netgemLibrary/v8/types/ParentalGuidance';
import type { ModalState } from '../../../redux/modal/reducers';

import { ParentalControlLockReason } from '../../../helpers/parentalControl/constsAndTypes';

// OTP sent by PTF is 6-digit long
export const OTP_LENGTH = 6;

export enum PinModalKind {
  CheckMaster,
  CreateMaster,
  CreateProfile,
  Delete,
  Modify,
  UnlockAdultContent,
  UnlockContent,
  UnlockProfile,
  UnlockPurchase,
  UnlockSettings,
}

export type PIN_DATA_MODAL_TYPE = {
  item?: NETGEM_API_V8_FEED_ITEM | null,
  kind: PinModalKind,
  lockReason?: ParentalControlLockReason,
  parentalGuidance?: NETGEM_API_V8_PARENTAL_GUIDANCE | null,
  profileId?: string,
};

export enum PinModalStep {
  AskOtp,
  EnterOtp,
  EnterOtpAndPin,
  EnterPin,
}

export enum ErrorSource {
  None,
  Otp,
  Pin,
}

export type ReduxPinModalDispatchToPropsType = {
  +localShowPinModal: (data: PIN_DATA_MODAL_TYPE) => void,
};

export type CompletePinModalPropType = {
  ...ModalState,
  ...ReduxPinModalDispatchToPropsType,
};

export type PinModalStateType = {
  currentOtp: string,
  currentPin: string,
  currentPinConfirmation: string,
  errorMsg: string,
  errorMsgAriaLabel: string | null,
  errorSource: ErrorSource,
  isWaitingOtp: boolean,
  item: NETGEM_API_V8_FEED_ITEM | null,
  kind: PinModalKind,
  parentalGuidance: NETGEM_API_V8_PARENTAL_GUIDANCE | null,
  step: PinModalStep,
};
